import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'

import { CommonModule } from '@angular/common'
import { CaseInputComponent, EurosPipe, HasPermissionDirective, MetaComponent, PaginationComponent, TableComponent } from 'src/app/abacus'
import { CaseListComponent } from '../../../components/case-list.component'
import { ResourceDefinition } from '../../../interfaces/resource-definition.interface'
import { Yield } from '../../../interfaces/yield.interface'
import { AuthService } from '../../../services/auth.service'
import { BreadcrumbService } from '../../../services/breadcrumb.service'
import { FilterService } from '../../../services/filter.service'
import { FlashMessageService } from '../../../services/flash-message.service'
import { ResourceService } from '../../../services/resource.service'
import { caseListTemplate } from '../../../templates/case-list.template'
import { roleDefinition } from '../role.definition'
import { roleYields } from '../role.yields'

@Component({
    template: caseListTemplate,
    standalone: true,
    imports: [
      CommonModule,
      EurosPipe,
      RouterModule,
      TableComponent,
      PaginationComponent,
      HasPermissionDirective,
      MetaComponent,
      CaseInputComponent
    ]
})
export class RoleListComponent extends CaseListComponent implements OnInit {
  override definition: ResourceDefinition = roleDefinition
  yields: Yield[] = roleYields

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService,
    filterService: FilterService,
    authService: AuthService
  ) {
    super(
      router,
      activatedRoute,
      breadcrumbService,
      resourceService,
      flashMessageService,
      authService,
      filterService
    )
  }

  ngOnInit() {
    this.initListView()
  }
}
